import { render, staticRenderFns } from "./curd.vue?vue&type=template&id=a7f9b086&scoped=true&"
import script from "./curd.vue?vue&type=script&lang=js&"
export * from "./curd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f9b086",
  null
  
)

export default component.exports